import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="relative">
        <div className="w-16 h-16 border-4 border-primary-200 border-t-primary-main rounded-full animate-spin"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <svg className="w-6 h-6 text-primary-main animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
      </div>
      <p className="mt-4 text-neutral-textPrimary font-semibold font-body">Đang tải thông tin hồ sơ...</p>
      <p className="mt-2 text-sm text-neutral-textSecondary font-body">Vui lòng chờ trong giây lát</p>
    </div>
  );
};

export default LoadingSpinner;
